import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { HashRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MSAL_CONFIG } from "./Azure/azure-authentication-config";
import { rememberAccount, trySilentSso } from "./Azure/silent-sso";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { ThemeProvider } from "./Context/ThemeContext";
import "./index.css";
// --- FIX: Fluent UI v9 ResizeObserver Patch ---
// Wraps ResizeObserver callbacks in requestAnimationFrame to prevent "loop completed" errors
// This fixes timing issues with Fluent UI v9 Dropdown positioning in Dialogs

// Toggle this to enable/disable ResizeObserver debugging logs
const ENABLE_RESIZE_OBSERVER_LOGGING = false;

const OriginalResizeObserver = window.ResizeObserver;

window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries: ResizeObserverEntry[], observer: ResizeObserver) => {
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) return;

        // Debug logging (toggle with ENABLE_RESIZE_OBSERVER_LOGGING)
        if (ENABLE_RESIZE_OBSERVER_LOGGING) {
          // Logging disabled
        }

        callback(entries, observer as any);
      });
    });
  }
} as any;
// --- FIX END ---

initializeIcons();

export const msalInstance = new PublicClientApplication(MSAL_CONFIG);

// Component
const AppProvider = () => (
  <FluentProvider theme={webLightTheme}>
    <ThemeProvider>
      <HashRouter>
        <App instance={msalInstance} />
      </HashRouter>
    </ThemeProvider>
  </FluentProvider>
);

// msal-browser v3+ requires initialize() to resolve before any other MSAL API
// (getActiveAccount, getAllAccounts, etc.) is called - calling them any earlier
// throws "uninitialized_public_client_application".
msalInstance.initialize().then(async () => {
  // Silent SSO from other PBS apps: the page is redirecting to Microsoft, render nothing.
  // Empty scopes match SignIn.tsx's loginRedirect(); API tokens are acquired later.
  if (await trySilentSso(msalInstance, [])) return;
  rememberAccount(msalInstance);

  // Default to using the first account if no account is active on page load
  if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  // ✅ Use createRoot instead of render
  const container = document.getElementById("rootEditProfile");
  if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(<AppProvider />);
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
